@if (!photos()?.length) {
  <div>
    <button (click)="reload()"> Reload </button>
  </div>
}

@if (photoApproved().approved && taskPhotos()?.length && (photoApproved().idReviewer|async) && photoApproved().approvedDate) {
  <div class="alert alert-success">
    {{ task()?.name }} Approved by {{(photoApproved().idReviewer|async)?.firstname}} {{(photoApproved().idReviewer|async)?.lastname}} on {{photoApproved().approvedDate | date:'dd/MMM/yyyy'}}
    @if (diagnosis()) {
      <span>with a diagnosis of: {{ diagnosis() }}</span>
    }
  </div>
}

@if (taskPhotos()?.length) {
  <div class="task-photos" layout="row" layout-align="space-around none" layout-wrap>
    @for (photo of taskPhotos(); track photo; let i = $index) {
      <div class="visit-photos-container {{photo.class}}">
        <div class="photo-image-container" [id]="'photo-image-container' + photo.id">
          <img class="photo-responsive" [file]="photo" [class.photo-rejected]="photo.rejected" alt="Photo" [id]="'photo-responsive' + photo.id" [showTimestamp]="true">
          <div class="overlay-buttons-container">
            @if (requiresAction() && !isUserDeleted()) {
              <div class="btns-row">
                @if (!photo.rejected) {
                  <div>
                    <button class="btn btn-danger" (click)="setRejectStatus(photo.id, true)" [disabled]="isOrderLocked()">Reject</button>
                  </div>
                }
                @if (photo.rejected && !photo.deleted) {
                  <div>
                    <button class="btn btn-success" (click)="setRejectStatus(photo.id, false)" [disabled]="isOrderLocked()">Approve</button>
                  </div>
                }
              </div>
            }
            <div class="btns-row">
              <button class="btn btn-default" (click)="openPhotoGallery(i)" [disabled]="isOrderLocked()">
                <i class="icon ion-search"></i>
              </button>
              <button (click)="rotate(photo.id)" id="rotate-image" class="btn btn-default">
                <i class="icon ion-android-refresh"></i>
              </button>
              @if (canPhotoBeDeleted(photo)) {
                <button id="deleteid" class="btn btn-default" (click)="showDeletePhotoConfirmationDialog(photo)">
                  <i class="icon icon-trash"></i>
                </button>
              }
            </div>
          </div>
        </div>
        @if ((this.photoFormGroups().get(photo.id)); as photoFormGroup) {
          <form [formGroup]="photoFormGroup">
            <div class="row">
              @if (isPhotoId(photo)) {
                <div class="col-xs-12">
                  <div class="select-box">
                    <select id="photo-type"
                      (change)="onFormControlChange(photoFormGroup)"
                      formControlName="photoType"
                      name="photo-type">
                      @if(!photoApproved().approved){
                        <option value=null>Select an option</option>
                        @for (type of types(); track type) {
                          <option [value]="type">{{ type }}</option>
                        }
                      } @else {
                        <option selected>@if(photo.file.id_type === 'National ID card'){
                          Citizen card
                        } @else {
                          {{photo.file.id_type}}
                        }</option>
                      }
                    </select>
                  </div>
                </div>
              }
            </div>
            @if (photo.rejected) {
              <div class="form-group">
                <label for="rejection-message" layout="row">
                  @if (isPending()) {
                    <span>Rejection Message</span>
                  }
                  <span flex></span>
                  <small class="warning-label color-gray-md">
                    <i class="icon icon-alert-triangle color-warning"></i> Will be sent to patient
                  </small>
                </label>
                <textarea id="rejection-message" class="form-control" (input)="onFormControlChange(photoFormGroup)" formControlName="rejectionNote" name="rejection-note" placeholder="Type your rejection message here"></textarea>
              </div>
            }
          </form>
        }
      </div>
    }
  </div>
}

<!-- Alerts -->
@if (waitingForUpload()) {
  <div class="alert alert-danger">Waiting for patient to reupload one or more photos...</div>
}
@if (localErrorMessage()) {
  <div class="alert alert-danger" (close)="updateErrorMessage(null)">{{ localErrorMessage() }}</div>
}

@if (isPending() && photos()?.length) {
  <div class="text-center">
    <button class="btn btn-danger" (click)="reject()" [disabled]="rejectCTADisabled()">Reject</button>
    <button class="btn btn-default" (click)="approve()" [disabled]="approveCTADisabled()">Approve</button>
  </div>
}
